// removed by extract-text-webpack-plugin
module.exports = {"table":"order-table--table--3QQoLW1a","key":"order-table--key--2V3oVePU","box-icon":"order-table--box-icon--1G9T4aCQ","boxIcon":"order-table--box-icon--1G9T4aCQ","id":"order-table--id--1-Ha2W6D","caption":"order-table--caption--3gXIh2NA"};


//////////////////
// WEBPACK FOOTER
// ./components/order-table/styles.css
// module id = ./components/order-table/styles.css
// module chunks = 0